export const set_auth = (auth,) => {
    return {
        type : 'SET_AUTH',
        auth,
    };
}